import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  (theme) => ({
    root: {
      border: '1.5px solid #C7C8CA',
      borderRadius: '4px',
      color: '#F37320',
      fontSize: '12px',
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 'bold',
      margin: '5px 5px',
      backgroundColor: '#FFF',
      '&:hover': {
        background: '#FFF',
      },
      '&:disabled': {
        color: '#FFF',
        backgroundColor: '#F37320',
        opacity: '50%',
      },
      padding: '6px 14px',
    },
    primary: {
      backgroundColor: '#F37320',
      color: '#FFF',
      '&:hover': {
        backgroundColor: '#F37320',
      },
    },
    tertiary: { color: '#4A4A4A', letterSpacing: '0.7px' },
    pdftab: {
      borderRadius: '4px',
      fontSize: '10px',
      '@media (max-height: 900px), (max-width: 1450px)': {
        fontSize: '7px',
      },
      color: '#545456',
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 'bold',
      backgroundColor: '#F8F8F8',
      '&:hover': {
        background: '#FFF',
      },
      padding: '6px 8px',
      // border: '2px solid red',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
    },
    pdftabselected: { color: '#F37320', border: '1.5px solid #F37320' },
    enlightentab: { fontSize: '12px', color: '#545456' },
    upload: { border: '1px solid #F37320' },
  }),
  { index: 1 },
)

export { useStyles }
